// extracted by mini-css-extract-plugin
module.exports = {"addressItem":"contractSimplified_addressItem__3aFtq","addressSection":"contractSimplified_addressSection__272bw"};